// Import react elements
import React, { useState } from 'react';

// Import components
import CreateButton from "global/components/CreateButton";

// Import css
import './KeywordTagsInput.css';



// Exported keyword input component
const KeywordTagsInput = ({ value, onChange, inputClassName, maxListHeight = 103, disabled = false, title, placeholderMsg = "Enter a keyword" }) => {

    
    // Internal input field value
    const [input, setInput] = useState('');



    // Add keyword if valid and not duplicate
    const addKeyword = () => {

        // Trim it
        const trimmed = input.trim();

        // Make sure it exists and it doesn't match any existing keywords
        if (trimmed && !value.includes(trimmed)) {

            // Add it
            onChange([...value, trimmed]);

        }

        // Empty the input
        setInput('');

    };



    // Remove keyword by index
    const removeKeyword = (index) => {

        // Create updated data by filtering out the one removed
        const updated = value.filter((_, i) => i !== index);

        // Pass onChange with updated data 
        onChange(updated);

    };



    // Handle Enter key
    const handleKeyDown = (e) => {

        // If Enter is pressed on keyboard
        if (e.key === 'Enter') {

            // Prevent form submit
            e.preventDefault(); 

            // Add the keyword
            addKeyword();

        }

    };



    return (

        <div className="keyword-input">

            <div className="keyword-input__controls horizontal-align-content-center">

                {title && <span><b>{title}</b></span>}

                <input
                    type="text"
                    placeholder={placeholderMsg}
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyDown={handleKeyDown}
                    maxLength="60"
                    className={inputClassName}
                    disabled={disabled}
                />

                <CreateButton title="Add" size="s" type="button" onClick={addKeyword} disabled={disabled} />

            </div>

            <div className="keyword-input__tags" style={{maxHeight: maxListHeight}}>

                {Array.isArray(value) && value.length > 0 && value.map((keyword, index) => (

                    <div key={index} className="keyword-input__tag">

                        {keyword}

                        {!disabled && 

                            <button
                                type="button"
                                className="keyword-input__remove"
                                onClick={() => removeKeyword(index)}
                            >

                                ✕

                            </button>

                        }
                             
                    </div>

                ))}

            </div>

        </div>

    );

};

export default KeywordTagsInput;